import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  state: {
    loading: false,
    catID: null,
    products: [],
    attributes: [],
    orderBy: "menu_order",
    tags: [],
  },
  getters: {
    products(state) {
      return state.products;
    },
    attributes(state) {
      return state.attributes;
    },
    tags(state) {
      return state.tags;
    },
    orderBy(state) {
      return state.orderBy;
    },
    loading(state) {
      return state.loading;
    },
    catID(state) {
      return state.catID;
    },
  },
  mutations: {
    setProducts(state, products) {
      state.products = products;
    },
    setAttributes(state, attributes) {
      state.attributes = attributes;
    },
    setTags(state, tags) {
      state.tags = tags;
    },
    setOrderBy(state, orderBy) {
      state.orderBy = orderBy;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setCatID(state, catID) {
      state.catID = catID;
    },
  },
  actions: {
    setProducts({ commit }, products) {
      commit("setProducts", products);
    },
    setAttributes({ commit }, attributes) {
      commit("setAttributes", attributes);
    },
    setTags({ commit }, tags) {
      commit("setTags", tags);
    },
    setOrderBy({ commit }, orderBy) {
      commit("setOrderBy", orderBy);
    },
    setCatID({ commit }, catID) {
      commit("setCatID", catID);
    },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js